import { Col, notification, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { localize, removeEmptyValues } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import React, { useState } from 'react';
import { downloadDictionary } from '/react4xp/parts/admin-dictionary/actions';

interface ColumnItem {
    title: string;
    dataIndex: string;
    render?: (item: any, row: any) => JSX.Element;
}

type Props = {
    translations: Record<string, string>;
    data: any;
    totalCount: number;
    columns: ColumnsType<ColumnItem>;
    columnsToShow?: Array<string>;
    isLoading: boolean;
    code: string;
    page: number;
    setPage: (page: number) => void;
    size: number;
    setSize: (size: number) => void;
    params: any;
};

const ReferenceBookList: React.FC<Props> = ({
    translations,
    code,
    data,
    totalCount,
    columns,
    isLoading,
    page,
    setPage,
    size,
    setSize,
    params,
    columnsToShow,
}) => {
    const columnToShow = columnsToShow || columns.map((column) => column?.dataIndex);
    const [loading, setLoading] = useState(false);

    const downloadingDictionary = async () => {
        setLoading(true);

        // const isVerified = await executeRecaptcha('reference_book_download_dict');
        // if (!isVerified) {
        //     return;
        // }

        downloadDictionary(
            {
                dictionaryCode: code,
                page: 0,
                size: 100000,
            },
            {
                columnsToShow: columnToShow,
                filterParams: removeEmptyValues(params),
            }
        )
            .then(({ data }) => {
                const filename = 'dictionary.xlsx';
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                notification.success({
                    message: 'Справочник успешно скачан!',
                    duration: 3,
                });
            })
            .finally(() => setLoading(false));
    };

    const handlePageNumberChange = (page) => {
        setPage(page);
    };

    const handleSizeChange = (current, pageSize) => {
        setSize(pageSize);
    };

    return (
        <div
            className="reference-table"
            style={{ flexGrow: 1 }}
        >
            <Table
                className="table-bordered"
                rowClassName={'table-row-dark'}
                pagination={{
                    current: page,
                    pageSize: size,
                    total: totalCount,
                    showSizeChanger: true,
                    onChange: handlePageNumberChange,
                    onShowSizeChange: handleSizeChange,
                }}
                dataSource={data}
                columns={columns}
                loading={isLoading}
                scroll={{
                    x: true,
                }}
            />

            {data && data.length !== 0 && (
                <Col
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginRight: 5,
                        marginBottom: 5,
                    }}
                >
                    <Button
                        type="primary"
                        color="white"
                        onClick={downloadingDictionary}
                        loading={loading}
                    >
                        {localize('button.download', translations)}
                    </Button>
                </Col>
            )}
        </div>
    );
};

export default ReferenceBookList;
